import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { RadioButton, RadioButtonGroup } from 'material-ui/RadioButton';
import FlatButton from 'material-ui/FlatButton';
import Paper from 'material-ui/Paper';

import Fetcher from '../../util/fetcher';
import AmpFormSeparationChar from '../../components/AmpFormSeparationChar';
import CheckboxGroup from '../../components/CheckboxGroup';
import StepProps from '../../constants/StepProps';

const styles = {
  flexBox: {
    display: 'flex'
  },
  flexBig: {
    flex: '2 0 0',
    margin: 8,
  },
  flexSmall: {
    flex: '1 0 0',
    margin: 8,
  },
  radioButton: {
    marginBottom: 4,
    marginLeft: 12,
  },
};

class AmplificationSettings extends Component {
  static contextTypes = {
    dataset: PropTypes.string.isRequired,
    firebaseToken: PropTypes.string.isRequired,
    history: PropTypes.object.isRequired,
    acl: PropTypes.object.isRequired,
  };

  static propTypes = StepProps;

  state = {
    selectedDeviceTypes: [],
    deviceTypeValues: ['pc', 'mobile', 'tablet', 'console', 'tv', 'car', 'smarthome', 'wearable', 'unknown'], // used to populate the checkboxgroup
    separationChar: 'same',
    useHouseholds: false,
    exportedUids: 'all',
  }

  componentWillUpdate(nextProps, nextState, nextContext) {
    this.handleValidation(nextState);
  }

  componentDidMount() {
    this.handleValidation(this.state);
  }

  handleLearnMore = () => {
    this.context.history.push(`/explore/householding`);
  }

  handleSeparatorChange = (val) => {
    this.setState({ separationChar: val });
  }

  handleDeviceTypeSelectionChange = (selectedDeviceTypes) => {
    this.setState({selectedDeviceTypes});
  }

  isFormValid(state = this.state) {
    const { selectedDeviceTypes, separationChar } = state;
    return selectedDeviceTypes.length > 0 && !!separationChar;
  }

  handleValidation(state) {
    // let prevFormValid = this.isFormValid(this.state);
    let nextFormValid = this.isFormValid(state);

    // If none are selected, we cannot continue.
    if (nextFormValid !== this.prevFormValid) {
      this.props.onValidationChange(nextFormValid);
      this.prevFormValid = nextFormValid;
    }
  }

  /**
   * Iterate through selected items to form a value that will be sent to the API.
   */
  getDeviceTypesValue() {
    const { selectedDeviceTypes, deviceTypeValues } = this.state;

    if (deviceTypeValues.length === selectedDeviceTypes.length) {
      return 'all';
    }
    return selectedDeviceTypes.join(',');
  }

  /**
   * This is called when the next button is pressed in the AmpStepper component.
   * AmpStepper waits for validation from this component before proceeding
   */
  complete() {
    const {hash} = this.props;
    const {firebaseToken, dataset} = this.context;

    // Create form commands and send this to the back-end
    const data = {
      separation_char: this.state.separationChar,
      include_source_uids: this.state.exportedUids === 'all',
      use_households: this.state.useHouseholds,
      device_types: this.getDeviceTypesValue(),
    }

    // Start processing with the current configuration
    // We'll start polling the progress in the next step
    Fetcher.init(firebaseToken)
      .ampProcess(hash, data, dataset)
      .then(this.props.onStepCompleteSuccess)
      .catch(this.props.onStepCompleteFailed);
  }
  
  render() {
    return (
      <Paper zDepth={1} className="ContentSpacing" style={styles.flexBox}>
        <div style={styles.flexSmall}>
          <h3>Amplify to:</h3>
          <CheckboxGroup
            values={this.state.deviceTypeValues}
            descriptions={['Desktop', 'Mobile', 'Tablet', 'Console', 'TV (OTT)', 'Car', 'Smart Home', 'Wearable', 'Other']}
            onChange={this.handleDeviceTypeSelectionChange}
          />
        </div>
        <div style={styles.flexSmall}>
          <h3>Use graph:</h3>
          <RadioButtonGroup
            name="use_households"
            valueSelected={this.state.useHouseholds}
            onChange={(event, val) => this.setState({ useHouseholds: val })}
          >
            <RadioButton
              value={false}
              label="Standard"
              style={styles.radioButton}
            />
            <RadioButton
              value={true}
              label="Households"
              style={styles.radioButton}
              disabled={!this.context.acl.householding}
            />
          </RadioButtonGroup>
          {!this.context.acl.householding && <FlatButton 
            label='learn more'
            onTouchTap={this.handleLearnMore}
          />}
        </div>
        <div style={styles.flexSmall}>
          <h3>Exported UIDs:</h3>
          <RadioButtonGroup
            name="exported_uids"
            valueSelected={this.state.exportedUids}
            onChange={(event, val) => this.setState({ exportedUids: val })}
          >
            <RadioButton
              value="all"
              label="Original UIDs + amplified UIDs"
              style={styles.radioButton}
            />
            <RadioButton
              value="extended"
              label="Only amplified UIDs"
              style={styles.radioButton}
            />
          </RadioButtonGroup>
          <br/>
          <h3>Desired output separator:</h3>
          <AmpFormSeparationChar onChange={this.handleSeparatorChange} defaultValue={this.state.separationChar} showSame={true}/>
        </div>
      </Paper>
    );
  }
}
export default AmplificationSettings;



// WEBPACK FOOTER //
// ./src/components/AmpStepSettings/index.jsx